// angular
import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { formatDate, DatePipe } from '@angular/common';

// material 
import { MatSort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table'
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

// models
import { Brand } from '../../shared/models/brand';
import { Mailing } from '../../shared/models/mailing';
import { MailingFile } from '../../shared/models/MailingFile';
import { SaveMailingRecord } from '../../shared/models/SaveMailingRecord';
import { CampaignType } from '../../shared/models/CampaignType';

// services
import { BrandService } from '../../shared/services/brand.service';
import { MailingService } from '../../shared/services/mailing.service'; 
import { MailingFileService } from '../../shared/services/mailingFile.service'; 
import { MailingRecordService } from '../../shared/services/mailingRecord.service';
import { CampaignTypeService } from '../../shared/services/campaignType.service';
import { AuthorizeService } from 'src/api-authorization/authorize.service';
import { SpinnerService } from '../../shared/components/spinner/spinner.service';

// flatfile
import FlatfileImporter from "flatfile-csv-importer"; 


// helper components
import { ConfirmationModalService } from '../../shared/components/modals/confirmation-modal/confirmation-modal.service';
import { ValidationService } from '../../shared/services/validation.service';
import { FileService } from '../../shared/services/file.service';
import { SelectOption } from '../../shared/models/selectOption';
import { MailingRecord } from '../../shared/models/MailingRecord';
import { NgbModalOptions, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MailingRecordEditFormComponent } from '../../shared/components/modals/mailing-record-edit-modal/mailing-record-edit.component';
import { QCReportComponent } from '../qc-report/qc-report.component';
import { interval } from 'rxjs';
import { ProcessRecall } from '../../shared/models/ProcessRecall';
 
declare var $: any;
 
@Component({
  selector: 'app-mailing-details',
  templateUrl: './mailing-details.component.html' 
})  

export class MailingDetailsComponent implements OnInit{
  public msg: string; 
  private id: number; // id
  private sub: any;
  public mailing: Mailing; // mailing model
  private importer: FlatfileImporter; // flatfile importer
  public results = "[]"; //Result data from importer
  public mailingRecord: SaveMailingRecord;
  public mailingFileId = 0;
  public mailingRecords = [];
  public userName: string;
  public userId: string;
  public exports: ProcessRecall[]; 

  mailingForm: FormGroup;
  mailingFormSubmitted = false; 
  isMailingReady = false;

  // MatPaginator Inputs
  length = 20;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  pageEvent: PageEvent;
  dataSource = new MatTableDataSource<MailingFile>();
  displayedColumns: string[] = ['action','name', 'totalRecords', 'createDate'];
  pipe = new DatePipe('en-US');

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private mailingService: MailingService,
    private mailingFileService: MailingFileService,
    private route: ActivatedRoute,
    private notification: MatSnackBar,
    private formBuilder: FormBuilder,
    //private authorizeService: AuthorizeService,
    private router: Router,
    private spinnerService: SpinnerService,
    private confirmationModalService: ConfirmationModalService,
    private fileService: FileService,
    private datepipe: DatePipe
    ) {  }

  // init
  ngOnInit() { 
     // show spinner on page load
    this.spinnerService.show();
      
    //// get current user
    //this.authorizeService.getUser().subscribe(result => {
    //  this.userName = result.name;
    //  this.userId = result.sub;
    //});
     
    // get url parameter id 
    this.sub = this.route.params.subscribe(params => {
      this.id = +params['id']; // (+) converts string 'id' to a number  
      this.msg = '';
      
      this.getMailing(this.id);

      // get mailing files
      this.getMailingFiles(this.id);
    });
     
  } 

  // gets mailing records based on mailing id
  getMailingFiles(id: number): void {
    // get mailingrecords
    this.mailingFileService.getAll(id).subscribe(result => {
      //if (result.length) { 
      this.dataSource.data = result;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      //} 

      this.isMailingReady = result.every(element => element.isProcessed === true);

    }, error => console.error(error));
  }
  // get mailing details
  getMailing(id: number) {
    // get mailing
    this.mailingService.getById(id).subscribe(result => {
       
      this.mailing = result;

      // build form
      if (this.mailing) {
        this.mailingForm = this.formBuilder.group({
          name: [this.mailing.name, [Validators.required, ValidationService.alphaNumericValidator]],
          brandId: [this.mailing.brandId, Validators.required],
          startDate: [this.mailing.startDate, Validators.required]
        });
      }

      // hide spinner
      setTimeout(() => {
        this.spinnerService.hide();
      }, 1500);

    }, error =>
      this.router.navigate(['/mailings/'])//console.error(error)
    );
  }
    
  // format gender
  convertGender(gender: string) {
    let g = 'F';

    switch (gender) {
      case 'F':
      case 'Female':
      case 'Unknown':
      case 'U':
        g = 'F';
        break;
      case 'M':
      case 'Male':
        g = 'M';
        break; 
    }
    return g;
  }

  // update mailing
  updateMailing() {
    this.mailingFormSubmitted = true;

    // stop here if form is invalid
    if (this.mailingForm.invalid) {
      return;
    }
      
    this.mailingService.update(this.mailing.id, { name: this.mailingForm.value["name"] } as Mailing)
      .subscribe(() =>
        this.showNotification('Your changes were saved!', 'Okay!'),
        this.mailing.name = this.mailingForm.value["name"]
    ); 
  }
   
  // delete mailing
  deleteMailing() {
    this.confirmationModalService.confirm('Confirm', 'Are you sure you want to delete this item?')
      .then((confirmed) => {
        if (confirmed) {

          this.mailingService.delete(this.mailing.id)
            .subscribe(() => {
              this.showNotification('This mailing has been deleted successfully!', 'Okay!');
              this.router.navigate(['/mailings/']);
            }
          ); 
        }
      }
      )
      .catch(() =>
        console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
    );
  }

  // filter for campaign mailing records
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  // show notification popup
  showNotification(msg: string, action: string) {
    this.notification.open(msg, action, { duration: 40000, panelClass: ['snackbar-success'] });
  }
   
  // export file for production
  exportForProduction(id: number) {
     // show spinner on page load
      this.spinnerService.show("Generating File");

      this.mailingService.getProcessRecall(id).subscribe(result => {

      //this.exports = result;

      this.spinnerService.hide();

        let headerList: Array<string> = [
        "id",
        "member",
        "patientID",
        //"clxPatientID",
        "firstName",
        "lastName",
        "address1",
        "address2",
        "city",
        "st",
        "zipCode",
        "sex",
        "dateOfBirth",
        "age", 
        "lastExam",
        "months",  
        "storeDescription",
        "storeNumber",
        "storeAddress1",
        "storeAddress2",
        "storeCity",
        "storeST",
        "storeZipCode", 
        "storePhone",
        "storeEmail",
        "storeHours",
        "storeUrl",
        "campaignType",
        "template",
        "frontImage",
        "frontCTA",
        "frontOffer",
        "frontLogo",
        "backLogo",
        "backCTA",
        "backBackground",
        "backTopLeftCopy",
        "backOfferBlock",
        "backBottomLeftCopy",
        "backStoreBlock",
        "style",
        "custom1",
        "custom2",
        "custom3",
        "custom4",
        "custom5"
      ];

        let fileName = this.mailing.name.replace(' ', '_') + '_' +this.datepipe.transform(this.mailing.startDate, 'MM-dd-yyyy');
        this.fileService.downloadFile(result, headerList, fileName);

    }, error => console.error(error));
     
  }

  // approve mailing
  approveMailing(id: number) {
     
    this.confirmationModalService.confirm('Confirm', 'Are you sure you want to approve this mailing?')
        .then((confirmed) => {
          if (confirmed) {

            this.spinnerService.show();

            this.mailingService.update(id, { name: this.mailingForm.value["name"], isApproved: true } as Mailing)
              .subscribe(() => {
                this.showNotification('This mailing file has been approved successfully!', 'Okay!');
                this.getMailing(this.id);
                this.spinnerService.hide();
              });
          }

        })
        .catch(() =>
          console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      ); 
  }
   
}
